// fallow-ignore-next-line boundary-violation -- shared sales helper lives in workspace zone; move pending
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { IntegrationStatusResponse } from "../../../components/types";

export type DynamicsStatusServiceType = {
    getDynamicsStatus(): Promise<IntegrationStatusResponse>;
    syncDynamics(): Promise<unknown>;
    disconnectDynamics(): Promise<unknown>;
};

export const dynamicsStatusService = (fetchService: IFetchService): DynamicsStatusServiceType => ({
    getDynamicsStatus: createCancelable((signal: AbortSignal): Promise<IntegrationStatusResponse> => {
        return fetchService.get(`sales-api/microsoft-dynamics/status`, undefined, {
            cancellation: signal,
        });
    }),
    disconnectDynamics: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/microsoft-dynamics/disconnect`, undefined, {
            cancellation: signal,
        });
    }),
    syncDynamics: createCancelable((signal: AbortSignal): Promise<unknown> => {
        return fetchService.get(`sales-api/sw-connector/microsoft-dynamics/sync`, undefined, {
            cancellation: signal,
        });
    }),
});
